var TwoFactorRequestStatus;
(function (TwoFactorRequestStatus) {
  TwoFactorRequestStatus["APPROVED"] = "APPROVED";
  TwoFactorRequestStatus["PENDING"] = "PENDING";
  TwoFactorRequestStatus["INVALID"] = "INVALID";
})(TwoFactorRequestStatus || (TwoFactorRequestStatus = {}));
export default TwoFactorRequestStatus;